import { useWeb3React } from '@pancakeswap/wagmi'
import {
  ArrowForwardIcon,
  Box,
  Button,
  Radio,
  Flex,
  Heading,
  Text,
  ButtonMenu,
  ButtonMenuItem,
} from '@pancakeswap/uikit'
import useLocalDispatch from 'contexts/LocalRedux/useLocalDispatch'
import { HistoryFilter } from 'state/types'
import { setHistoryFilter, setHistoryPaneState } from 'state/predictions'
import { useGetHistoryFilter, useGetIsFetchingHistory } from 'state/predictions/hooks'
import { useTranslation } from '@pancakeswap/localization'
import styled from 'styled-components'

const Filter = styled.label`
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  margin-right: 16px;

  .radio-history {
    width: 16px;
    height: 16px;

    background-color: #dbd6d6;

    &:checked {
      /* width: 7px;
      height: 7px;

      top: 5.2px;
      left: 4.5px;
*/
      background-color: #ffffff;
      border: 4px solid ${({ theme }) => theme.colors.primary};
    }
  }
`

const StyledHeader = styled(Box)`
  flex: none;
  padding: 72px 24px 24px;

  .Back-btn {
    color: ${({ theme }) => theme.colors.text};
    &:hover {
      color: ${({ theme }) => theme.colors.primary};
    }
  }

  @media screen and (max-width: 991px) {
    padding-top: 24px;
  }
`

const ButtonMenuContainer = styled.div`
  /* margin-bottom: 16px; */
  width: 100%;

  & > div {
    width: 100%;
  }

  & button {
    width: 100%;
    border-radius: 12px;
  }
`

const CloseHistoryButton = styled(Button)`
  color: ${({ theme }) => theme.colors.white};
  font-size: 14px;
  font-weight: 700;
`

interface HeaderProps {
  activeTab: HistoryTabs
  setActiveTab: (value: HistoryTabs) => void
}

export enum HistoryTabs {
  ROUNDS,
  PNL,
}

const Header: React.FC<React.PropsWithChildren<HeaderProps>> = ({ activeTab, setActiveTab }) => {
  const historyFilter = useGetHistoryFilter()
  const isFetchingHistory = useGetIsFetchingHistory()
  const { t } = useTranslation()
  const dispatch = useLocalDispatch()
  const { account } = useWeb3React()

  const handleClick = () => {
    dispatch(setHistoryPaneState(false))
  }

  const handleChange = (newFilter: HistoryFilter) => async () => {
    if (newFilter !== historyFilter) {
      dispatch(setHistoryFilter(newFilter))
    }
  }

  const switchTab = async (tabIndex: number) => {
    setActiveTab(tabIndex)
    await handleChange(HistoryFilter.ALL)()
  }

  return (
    <StyledHeader>
      <Flex alignItems="center" justifyContent="space-between" mb="16px">
        <Text fontSize="16px" fontWeight="700" lineHeight="140%">
          {t('History')}
        </Text>
        {/* <CloseHistoryButton onClick={handleClick} variant="text" endIcon={<ArrowForwardIcon color="white" />} px="0">
          {t('Close')}
        </CloseHistoryButton> */}
        <ArrowForwardIcon className="Back-btn" onClick={handleClick} style={{ cursor: 'pointer' }} />
      </Flex>
      <ButtonMenuContainer>
        <ButtonMenu activeIndex={activeTab} scale="sm" variant="tertiary" onItemClick={switchTab}>
          <ButtonMenuItem>{t('Rounds')}</ButtonMenuItem>
          <ButtonMenuItem>{t('PNL')}</ButtonMenuItem>
        </ButtonMenu>
      </ButtonMenuContainer>
      {activeTab === HistoryTabs.ROUNDS && (
        <>
          <Text color="white60" mt="20px" mb="8px">
            {t('Filter')}
          </Text>
          <Flex alignItems="center" justifyContent="space-between">
            <Filter>
              <Radio
                className="radio-history"
                scale="sm"
                checked={historyFilter === HistoryFilter.ALL}
                disabled={isFetchingHistory || !account}
                onChange={handleChange(HistoryFilter.ALL)}
              />
              <Text ml="8px">{t('All')}</Text>
            </Filter>
            <Filter>
              <Radio
                className="radio-history"
                scale="sm"
                checked={historyFilter === HistoryFilter.COLLECTED}
                disabled={isFetchingHistory || !account}
                onChange={handleChange(HistoryFilter.COLLECTED)}
              />
              <Text ml="8px">{t('Collected')}</Text>
            </Filter>
            <Filter>
              <Radio
                className="radio-history"
                scale="sm"
                checked={historyFilter === HistoryFilter.UNCOLLECTED}
                disabled={isFetchingHistory || !account}
                onChange={handleChange(HistoryFilter.UNCOLLECTED)}
              />
              <Text ml="8px">{t('Uncollected')}</Text>
            </Filter>
          </Flex>
        </>
      )}
    </StyledHeader>
  )
}

export default Header
